import { withDefault } from "collection-utils";
import { IconName } from "../../named-icons";
import { ComponentBuilder, ComponentConfiguratorContext, ComponentDescriptor, PropertyDescriptor } from ".";
import { SerializedComponent } from "../../components/SerializedApp";
import { getDocURL } from "../../docUrl";
import { makeText } from "../builder-utils";
import {
    ComponentDescription,
    ComponentKind,
    InputOutputTables,
    MutatingScreenKind,
    PropertyDescription,
    PropertyKind,
    TableGlideType,
} from "../description";
import { makeTextPropertyDescriptor } from "./descriptor-utils";
import { ComponentHandlerBase } from "./handler";
import { EnumPropertyHandler } from "./property-handlers";
import { PropertySection } from "./property-sections";
import { getEnumProperty } from "./property-utils";
import { TextBoxJustify } from "./text-box-types";
import { Mood, moodCases } from "./mood";

const ComponentKindHint: ComponentKind = "hint";

const expand = (val: string, icon?: IconName) => ({
    value: val,
    label: val,
    icon,
});

const hintMoodPropertyHandler = new EnumPropertyHandler(
    { mood: Mood.Default },
    "Mood",
    "Mood",
    moodCases,
    PropertySection.Design,
    "dropdown"
);

// FIXME: THIS IS A LOT OF COPYPASTA
const defaultJustify = TextBoxJustify.Left;
const textBoxJustifyProperty: PropertyDescriptor = {
    kind: PropertyKind.Enum,
    property: { name: "justify" },
    label: "Align",
    menuLabel: "Align",
    cases: [
        expand(TextBoxJustify.Left, "leftAlign"),
        expand(TextBoxJustify.Center, "centerAlign"),
        expand(TextBoxJustify.Right, "rightAlign"),
        expand(TextBoxJustify.Justify, "justifyAlign"),
    ],
    defaultCaseValue: defaultJustify,
    section: PropertySection.Design,
    visual: "small-images",
};
function getTextBoxJustify(desc: HintComponentDescription): TextBoxJustify {
    return withDefault(getEnumProperty(desc.justify), defaultJustify);
}

interface HintComponentDescription extends ComponentDescription {
    readonly propertyName: PropertyDescription;
    readonly title?: PropertyDescription;
    readonly text?: PropertyDescription;
    readonly mood: PropertyDescription;
    readonly justify?: PropertyDescription;
}

export class HintComponentHandler extends ComponentHandlerBase<HintComponentDescription> {
    constructor() {
        super(ComponentKindHint);
    }

    public get needsColumns(): boolean {
        return false;
    }

    public entryForTableColumn(
        builder: ComponentBuilder,
        desc: HintComponentDescription,
        { input }: InputOutputTables
    ): SerializedComponent {
        const { b } = builder;
        return b.ui("Hint", {
            title: makeText(builder, desc.title, input, true),
            text: makeText(builder, desc.text, input, true),
            mood: b.constant(hintMoodPropertyHandler.getEnum(desc)),
            justify: b.constant(getTextBoxJustify(desc)),
        });
    }

    public getDescriptor(
        _desc: HintComponentDescription,
        _table: TableGlideType | undefined,
        _ccc: ComponentConfiguratorContext,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): ComponentDescriptor<HintComponentDescription> {
        const properties: PropertyDescriptor[] = [
            makeTextPropertyDescriptor("title", "Title", "Enter title", true, mutatingScreenKind, {
                searchable: false,
            }),
            makeTextPropertyDescriptor("text", "Text", "Enter hint text", true, mutatingScreenKind, {
                searchable: true,
            }),
            hintMoodPropertyHandler,
            textBoxJustifyProperty,
            ...this.getBasePropertyDescriptors(),
        ];

        return {
            name: "Hint",
            description: "Special text",
            img: "componentHintText",
            group: "Text",
            helpUrl: getDocURL("hint"),
            properties,
        };
    }
}
